import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { HeroSlideshow } from "../components/gallery/HeroSlideshow";
import { ImageMarquee } from "../components/gallery/ImageMarquee";
import { HorizontalAlbum } from "../components/gallery/HorizontalAlbum";
import { StackedMoments } from "../components/gallery/StackedMoments";
import { AlbumGrid } from "../components/gallery/AlbumGrid";
import { Lightbox } from "../components/gallery/Lightbox";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { WordReveal } from "../components/WordReveal";
import { AnimatedNumber } from "../components/AnimatedNumber";
import { ALBUMS, GALLERY } from "../data/gallery";
import type { GalleryItem } from "../data/gallery";
import { IMAGES } from "../data/images";
type LightboxState = {
  items: GalleryItem[];
  index: number;
} | null;
export function Gallery() {
  const [lightbox, setLightbox] = useState<LightboxState>(null);
  function open(items: GalleryItem[], id: string) {
    const index = Math.max(0, items.findIndex(i => i.id === id));
    setLightbox({
      items,
      index
    });
  }
  const openFromAll = (id: string) => open(GALLERY, id);
  return <>
      <HeroSlideshow data-id="element-1041" data-mp="2b9teg3ueg5p2" />

      <main data-id="element-1042" data-mp="2b6fcuxtk80io">
        <section className="mx-auto grid max-w-[1440px] gap-12 px-5 py-24 md:px-9 lg:grid-cols-12 lg:py-36" data-id="element-1043" data-mp="2b6p5kt5zols2">
          <div className="lg:col-span-8" data-id="element-1044" data-mp="32zofgxrmdjtk">
            <p className="text-xs font-semibold tracking-[0.18em] text-[#bb1e35]" data-id="element-1045" data-mp="330zl734ml1nb">LIFE AT MCC, IN PICTURES</p>
            <WordReveal as="p" text="Before you visit, take a look around. These are the rooms, courts, studios and celebrations your child will call their own." className="mt-8 text-3xl font-medium leading-[1.12] tracking-[-0.045em] md:text-5xl" data-id="element-1046" data-mp="37y96c6kzer5c" />
          </div>
          <div className="grid grid-cols-2 content-end gap-6 border-t border-[#061f38] pt-6 lg:col-span-3 lg:col-start-10" data-id="element-1047" data-mp="1ijbevcsvwmge">
            <Reveal data-id="element-1048" data-mp="1njpdy5cicm2a">
              <p className="text-6xl font-medium tracking-[-0.07em]" data-id="element-1049" data-mp="1nk8y7spmrmjh"><AnimatedNumber value={GALLERY.length} data-id="element-1050" data-mp="3p8d3j8mdtxhy" /></p>
              <p className="mt-2 text-sm text-[#4f5963]" data-id="element-1051" data-mp="3p9xygzclzigc">moments</p>
            </Reveal>
            <Reveal delay={0.1} data-id="element-1052" data-mp="3k9sb3vddgi42">
              <p className="text-6xl font-medium tracking-[-0.07em] text-[#bb1e35]" data-id="element-1053" data-mp="3fi215qicjwd6"><AnimatedNumber value={ALBUMS.length} data-id="element-1054" data-mp="3fg7bjyw4rg2r" /></p>
              <p className="mt-2 text-sm text-[#4f5963]" data-id="element-1055" data-mp="3bfnhx5armuld">albums</p>
            </Reveal>
          </div>
        </section>

        <section className="pb-24 md:pb-32" aria-label="Scrolling gallery" data-id="element-1056" data-mp="36j6ru5k0a65n">
          <ImageMarquee items={GALLERY} onOpen={openFromAll} data-id="element-1057" data-mp="31hhf8lh4xkfg" />
          <p className="mx-auto mt-5 max-w-[1440px] px-5 text-xs text-[#6b7378] md:px-9" data-id="element-1058" data-mp="2wjg02bmty599">Hover to pause · Select any photo to view full screen</p>
        </section>

        <HorizontalAlbum items={GALLERY.slice(0, 8)} onOpen={openFromAll} data-id="element-1059" data-mp="2sjnl9h6uf2vg" />

        <StackedMoments data-id="element-1060" data-mp="ur1f13ozokom" />

        <AlbumGrid onOpen={open} data-id="element-1061" data-mp="ur9u928l422z" />
      </main>

      <CTABand eyebrow="SEE IT IN PERSON" title="Pictures are a start. A visit says more." image={IMAGES.rooftop} data-id="element-1062" data-mp="qpy5eyxjbkvu" />

      <AnimatePresence data-id="element-1063" data-mp="28n1i3re23sis">
        {lightbox && <Lightbox items={lightbox.items} index={lightbox.index} onClose={() => setLightbox(null)} onChange={index => setLightbox(prev => prev ? {
        ...prev,
        index
      } : prev)} data-id="element-1064" data-mp="28m9ub2qpaz32" />}
      </AnimatePresence>
    </>;
}